export { default } from "./StreamTagCondition";
